export default __webpack_public_path__ + "static/media/funding.dd8b23bb.jpg";